export default "__VITE_ASSET__BSphIBsx__"